import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const BookVerticalCardIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.75" y="4.25" width="18.5" height="24.5" rx="1.25" stroke={fill} strokeWidth="1.5"/>
    <path d="M15.7136 17.2864L12.2512 17.2864C12.1118 17.2864 11.9977 17.1732 12 17.0337C12.0006 17.0025 12.0012 16.9846 12.0017 16.9737C12.0093 16.8319 12.1158 16.7149 12.2578 16.7149L15.7136 16.7149L15.7136 13.2526C15.7136 13.1131 15.8267 13 15.9662 13L16.0325 13C16.172 13 16.2851 13.1131 16.2851 13.2526L16.2851 16.7149L19.7474 16.7149C19.8869 16.7149 20 16.828 20 16.9675V17.0338C20 17.1733 19.8869 17.2864 19.7474 17.2864L16.2851 17.2864L16.2851 20.7488C16.2851 20.8882 16.1718 21.0023 16.0324 21C16.0011 20.9994 15.9833 20.9988 15.9724 20.9983C15.8306 20.9907 15.7136 20.8842 15.7136 20.7422L15.7136 17.2864Z" fill={fill} stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default BookVerticalCardIcon;import { FC } from 'react';

type PropsT = {
  fill?: string;
};

const BookVerticalCardIcon: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6.75" y="4.25" width="18.5" height="24.5" rx="1.25" stroke={fill} strokeWidth="1.5"/>
    <path d="M15.7136 17.2864L12.2512 17.2864C12.1118 17.2864 11.9977 17.1732 12 17.0337C12.0006 17.0025 12.0012 16.9846 12.0017 16.9737C12.0093 16.8319 12.1158 16.7149 12.2578 16.7149L15.7136 16.7149L15.7136 13.2526C15.7136 13.1131 15.8267 13 15.9662 13L16.0325 13C16.172 13 16.2851 13.1131 16.2851 13.2526L16.2851 16.7149L19.7474 16.7149C19.8869 16.7149 20 16.828 20 16.9675V17.0338C20 17.1733 19.8869 17.2864 19.7474 17.2864L16.2851 17.2864L16.2851 20.7488C16.2851 20.8882 16.1718 21.0023 16.0324 21C16.0011 20.9994 15.9833 20.9988 15.9724 20.9983C15.8306 20.9907 15.7136 20.8842 15.7136 20.7422L15.7136 17.2864Z" fill={fill} stroke={fill} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default BookVerticalCardIcon;